import { getLinearScale } from '../../NonConstantUtils';

// This function ensures that the min and max values in the domain maps to
// values that are a distance `padding` away from the min and max of the range:
export default (domain: [number, number], range: [number, number], padding: number) => {
  const originalScale = getLinearScale(domain, range);
  const [prevDomainStart, prevDomainEnd] = domain;
  const [rangeStart, rangeEnd] = range;
  let paddingInDomain: number;
  if (rangeStart < rangeEnd) {
    paddingInDomain = Math.abs(originalScale.invert(rangeStart + padding) - prevDomainStart);
  } else {
    paddingInDomain = Math.abs(originalScale.invert(rangeStart - padding) - prevDomainStart);
  }
  let newDomainStart: number, newDomainEnd: number;
  if (prevDomainStart < prevDomainEnd) {
    newDomainStart = prevDomainStart - paddingInDomain;
    newDomainEnd = prevDomainEnd + paddingInDomain;
  } else {
    newDomainStart = prevDomainStart + paddingInDomain;
    newDomainEnd = prevDomainEnd - paddingInDomain;
  }
  return {
    scale: getLinearScale([newDomainStart, newDomainEnd], range),
    domainStart: newDomainStart,
    domainEnd: newDomainEnd,
  };
};
